import { Flex, Col, Form, Input, Select, Space, InputNumber, Button, Upload, Modal } from "antd"
import { PlusOutlined, LoadingOutlined } from "@ant-design/icons"
import { useEffect, useState } from "react";
import { beforeUpload, getBase64 } from "../../../../helper/Base64";
import { useSelector } from 'react-redux';
import { selectCurrencies } from "../../../../app/store/reducers/currency/currencyReducer";
import { selectCategories } from "../../../../app/store/reducers/category/categoryReducer";
import { useLocation } from "react-router-dom";



const ProductForm = () => {
  const currencies = useSelector(selectCurrencies)
  const categories = useSelector(selectCategories)
    const form = Form.useFormInstance();
    const location = useLocation()?.pathname?.includes("register");
    const [loading, setLoading] = useState(false);
  const [imageUrl, setImageUrl] = useState()
  // const [fileList, setFileList] = useState([])
  const [fileList, setFileList] = useState([])
  const handleChange = (info) => {
    // console.log("info", info);
    
    setFileList(info?.fileList)
    // console.log(info.file.status, "test");
    if (info?.file?.status === "uploading") {
      setLoading(true);
      return;
    } else if (info?.file?.status === "removed") {
      productImage(null)
    } else {
      // if (info?.file?.status === "done") {
      // Get this url from response in real world.
      // if () {
        
      // } else {
        getBase64(info?.fileList[0]?.originFileObj, (url) => {
        // console.log("url", url);
        
        const img = url?.split(",")[1]
        setLoading(false);
        setImageUrl(url);
        productImage({
          base64: img,
          filename: info?.fileList[0]?.name,
          size: info?.fileList[0]?.size
        })
      });
      // }
    // }
    }
  };
  const [show, setShow] = useState(false)

  const productImage = (file) => {
    form.setFieldValue("image", file)
  }

  const uploadButton = (
    <button
      style={{
        border: 0,
        background: "none",
      }}
      type="button"
    >
      {loading ? <LoadingOutlined /> : <PlusOutlined />}
      <div
        style={{
          marginTop: 8,
        }}
      >
        Upload
      </div>
    </button>
  );


  
  useEffect(() => {
    if (form.getFieldValue('image')) {
      setFileList([form.getFieldValue('image')])
      setImageUrl(form.getFieldValue('image'))
    }
  },[])


    const onChange = (e) => {
        console.log("test version category", e)
    }

    const testCategory = [
        {
            id: "asdf123",
            name: "USA"
        },
        {
            id: "qqwer123",
            name: "UZB"
        },
        {
            id: "fdwerq654",
            name: "RUB"
        },
    ]

    const suffixSelector = (
        // <Form.Item name="suffix" noStyle>
        <Form.Item name="currency_id" noStyle>
          <Select
          placeholder="Select a option and change input text above"
        //   onChange={onChange}
        //   allowClear
        >
            {currencies?.map((price, i) => {
                return (
                    <Select.Option key={price?.id} value={price.id}>{price?.name}</Select.Option>
                )
            })}
        </Select>
        </Form.Item>
      );


    return (
    <>
        <Flex className="d-flex align-items-center align-items-sm-start justify-content-sm-around flex-sm-row flex-column" wrap="wrap">
        <Col lg={9} sm={11} className="w-100">
          <Form.Item
            name="name"
            label="name"
            rules={[
              {
                required: true,
                message: "Please fill this field",
              },
            ]}
          >
            <Input placeholder="name" />
          </Form.Item>
        </Col>

        <Col lg={9} sm={11} className="w-100">
        <Form.Item label="Price" name="amount">
      {/* <Space.Compact> */}
      {/* <Form.Item
            name="price.amount"
            label="price.amount"
            rules={[
              {
                required: true,
                message: "Please fill this field",
              },
            ]}
          >
            <Input placeholder="price.amount" typeof="number" />
          </Form.Item>
          <Form.Item
        name="price.currency_id"
        label="Price.currency_id"
        rules={[
          {
            required: true,
          },
        ]}
      >
        <Select
          placeholder="Select a option and change input text above"
        //   onChange={onChange}
          allowClear
        >
            {testCategory.map((price, i) => {
                return (
                    <Select.Option key={price?.id} value={price.id}>{price?.name}</Select.Option>
                )
            })}
        </Select>
      </Form.Item> */}
      {/* </Space.Compact> */}
      <InputNumber
          addonAfter={suffixSelector}
          style={{
            width: '100%',
          }}
        />
    </Form.Item>
        </Col>

        {/* <Col lg={9} sm={11} className="w-100">
          <Form.Item
            name="price.amount"
            label="price.amount"
            rules={[
              {
                required: true,
                message: "Please fill this field",
              },
            ]}
          >
            <Input placeholder="price.amount" typeof="number" />
          </Form.Item>
        </Col> */}

        <Col lg={9} sm={11} className="w-100">
        <Form.Item
        name="category_id"
        label="category"
        rules={[
          {
            required: true,
          },
        ]}
      >
        <Select
          placeholder="Select a option and change input text above"
          onChange={onChange}
          allowClear
        >
            {categories?.map((category, i) => {
                return (
                    <Select.Option key={category?.id} value={category.id}>{category?.name}</Select.Option>
                )
            })}
        </Select>
      </Form.Item>
        </Col>
        <Col lg={9} sm={11} className="w-100">
          <Form.Item
            name="residual"
            label="residual"
            rules={[
              {
                required: true,
                message: "Please fill this field",
              },
            ]}
          >
            <Input placeholder="residual" />
          </Form.Item>
        </Col>
        <Col xl={10} className="w-100">
        <Form.Item
        name="description"
        label="Description"
        // rules={[
        //   {
        //     required: true,
        //     message: 'Please input Intro',
        //   },
        // ]}
      >
        <Input.TextArea rows={4} showCount maxLength={100} />
      </Form.Item>
        </Col>
        <Col xl={10} className="w-100">
        <Form.Item label="Upload" valuePropName="fileList">
        <div>
              <Upload
                name="image"
                listType="picture-card"
                fileList={fileList}
                // action="https://run.mocky.io/v3/435e224c-44fb-4773-9faf-380c5e6a2188"
                // beforeUpload={beforeUpload}
                beforeUpload={() => false}
                onChange={handleChange}
                onPreview={() => setShow(true)}
                // onRemove={(e) => console.log(e)}
              >
                {fileList?.length > 0 ? null : uploadButton}
              </Upload>
              {/* <Upload
  listType="picture-card"
  fileList={fileList}
  beforeUpload={() => false}
  onChange={({ file, fileList }) => {
    setFileList(fileList);
    console.log("into info", file, fileList);
    

    if (file.originFileObj) {
      getBase64(file.originFileObj, (url) => {
        setImageUrl(url);

        productImage({
          base64: url.split(",")[1],
          filename: file.name,
          size: file.size,
        });
      });
    }
  }}
>
  {fileList.length === 0 && uploadButton}
</Upload> */}
              <Modal open={show} title="Image" footer={null} onCancel={() => setShow(false)}>
        <img
          src={imageUrl?.url ? imageUrl?.url : imageUrl}
          alt="example"
          style={{
            width: '100%',
          }}
        />
      </Modal>
            </div>
        </Form.Item>
        </Col>
        <Col className="d-flex justify-content-center w-100">
            <Button type="primary" htmlType="submit">{location ? 'Register' : 'Edit'}</Button>
        </Col>
        </Flex>
    </>
  )
}

export default ProductForm